import PageHeader from '@features/users/adminPanel/components/PageHeader/PageHeader';
import AdminPanelPage from '@features/users/adminPanel/containers/AdminPanelPage/AdminPanelPage.tsx';
import { LeaveGuardModalProvider } from '@shared/providers/LeaveGuardModalProvider/LeaveGuardModalProvider';

export default function AdminPanelPageLayout() {
  return (
    <LeaveGuardModalProvider>
      <PageHeader />
      <AdminPanelPage />
    </LeaveGuardModalProvider>
  );
}
